import React from 'react';
import PropTypes from 'prop-types';
import RowTitle from 'components/list/Filters/layout/RowTitle';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { SelectField, MenuItem } from 'material-ui';

class MatchTypes extends React.Component {
    componentDidMount() {
        const {
            defaultValue,
            input,
        } = this.props;

        const value = input.value ? input.value : defaultValue;

        input.onChange(value);
    }

    render() {
        const {
            translate,
            values,
            input: {
                onChange,
                ...otherInputProps
            },
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        if (values.length === 1) {
            const matchType = values[0];

            return (
                <RowTitle>
                    { translate(`filters.matchtypes.${ matchType }`) }
                </RowTitle>
            );
        }

        return (
            <SelectField
                { ...otherInputProps }
                fullWidth={ true }
                hintText={ translate('filters.matchtype') }
                onChange={ (event, key, payload) => {
                    return onChange(payload);
                } }
            >
                { values.map((matchType) => {
                    return <MenuItem
                        key={ matchType }
                        value={ matchType }
                        primaryText={ translate(`filters.matchtypes.${ matchType }`) }
                    />;
                }) }
            </SelectField>
        );
    }
}

MatchTypes.defaultProps = {
    values: [],
};

MatchTypes.propTypes = {
    defaultValue: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    values: PropTypes.array,
};

export default translate(MatchTypes);



// WEBPACK FOOTER //
// ./src/components/list/Filters/form/components/MatchTypes.js